<template>
  <div class="page-content-wrapper">
    <div v-if="loading" class="text-center mt-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-else>
      <div class="row mt-0">
        <div class="col-md-12">
          <div class="card rounded-3 shadow border-1">
            <div
              class="card-header bg-white border-0 d-flex justify-content-between align-items-center"
            >
              <p class="text-s fw-bold">Service Forms</p>
              <button
                type="button"
                class="btn btn-dark rounded-3 fw-bold text-xxs text-white float-end shadow"
                data-bs-toggle="modal"
                data-bs-target="#add_service"
                @click="clean_form_modal"
              >
                <i class="fas fa-plus"></i> Add Custom Service
              </button>
            </div>
            <div class="card-body">
              <CustomTable
                :columns="columns"
                :fetchData="get_custom_service"
                :hasActions="true"
                :key="servicesTableKey"
                tableKey="custom_services"
              >
                <template v-slot:cell-internal_use="{ row }">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      :id="'internalUseSwitch_' + row.id"
                      v-model="row.internal_use"
                      :disabled="row.internal_use === null"
                      @change="update_internal_use(row.id, row.internal_use)"
                    />
                    <label for="">
                      <span
                        class="text-muted text-xxs"
                        v-if="row.internal_use === null"
                        >External Use Only</span
                      >
                      <span
                        class="text-muted text-xxs"
                        v-else-if="row.internal_use"
                        >Yes</span
                      >
                      <span
                        class="text-muted text-xxs"
                        v-else-if="!row.internal_use"
                        >No</span
                      >
                    </label>
                  </div>
                </template>
                <template v-slot:actions="{ row }">
                  <button
                    class="btn bg-green rounded-3 btn-sm me-2 text-white text-xxs shadow"
                    @click.prevent="manage_service(row.id)"
                  >
                    Manage Service
                  </button>
                  <button
                    class="btn btn-dark rounded-3 text-white fw-bold btn-sm text-xxs shadow"
                    @click="edit_form(row)"
                  >
                    Edit
                  </button>
                </template>
              </CustomTable>
            </div>
          </div>
        </div>
      </div>

      <!-- Add Service Modal -->
      <div
        class="modal fade"
        id="add_service"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="add_service_label"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-white rounded-3">
            <div class="modal-header border-bottom-0">
              <h5 class="modal-title text-s fw-bold" id="add_service_label">
                Add Custom Service
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="form-group mb-3">
                <input
                  type="text"
                  v-model="service_name"
                  class="form-control text-xxs text-dark p-3 shadow-sm"
                  placeholder="Service Name"
                />
                <small
                  class="text-danger p-2 text-xxs fw-bold d-none name-error-message"
                  >Please enter a service name</small
                >
                <small
                  class="text-danger p-2 text-xxs fw-bold d-none error-messages"
                ></small>
              </div>
              <div class="text-end">
                <button
                  type="button"
                  class="btn bg-green float-end shadow text-xxs fw-bold"
                  @click.prevent="create_custom_service"
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Form Modal -->
      <div
        class="modal fade"
        id="edit_form_modal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="edit_form_modal_label"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-white rounded-3">
            <div class="modal-header border-bottom-0">
              <h5 class="modal-title text-s fw-bold" id="edit_form_modal_label">
                Edit Custom Service Details
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="form-group mb-3">
                <input
                  type="text"
                  v-model="service_name"
                  class="form-control text-xs rounded-small p-3 shadow-sm"
                  placeholder="Service Name"
                />
                <small
                  class="text-danger p-2 text-xxs fw-bold d-none name-error-message"
                  >Please enter a service name</small
                >
              </div>
              <button
                type="button"
                class="btn bg-green float-end shadow secondary-text-dark text-xxs fw-bold"
                @click="update_form"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./form_management.js"></script>
